/**
 * One colour per ISR signal type, shared by the map dots and the panel chips
 * so a cyan dot on the map is the cyan chip in the list. Its own module so the
 * panel does not pull the map library in to read a colour.
 */

import type { SignalType } from '@/api/federation';

export const SIGNAL_COLORS: Record<SignalType, string> = {
  wifi: '#38bdf8',
  bluetooth: '#34d399',
  adsb: '#fbbf24',
  ais: '#22d3ee',
  rfid: '#a78bfa',
  cellular: '#f472b6',
  lora: '#2dd4bf',
  zigbee: '#fb923c',
  gnss: '#4ade80',
  radar: '#f87171',
  rf: '#e879f9',
  unknown: '#a1a1aa',
};
